<template>
    <div class="People">
        <div class="row record-section-row">
            <div class="col">
                <h4>Professionals:</h4>
                <div>
                    <ContactDisplayAndEdit :edit-mode="EditMode"
                                           :global-update="false"
                                           get-endpoint="Core/Clients/Contacts/Professionals/GetContacts"
                                           :get-payload="{Id: ChildRecordData.Id}"
                                           add-edit-endpoint="Core/Clients/Contacts/Professionals/AddEditContact"
                                           :add-edit-payload="{ChartID: ChildRecordData.Id}"
                                           delete-endpoint="Core/Clients/Contacts/Professionals/DeleteContact"
                                           :require-dob="false"
                                           contact-category="Professionals"
                                           :relationship-options="ProfessionalOptions"
                                           relationship-label="Child"
                                           :display-age="false"
                                           :display-relationship="true"
                                           :agency-input="true"
                                           :professional-dropdown-enabled="true"
                                           professional-dropdown-enabled-endpoint="Core/Clients/Contacts/Professionals/GetAllContactsInSubProgram"
                                           :professional-dropdown-enabled-payload="{Id: ChildRecordData.SubProgramID}"
                                           :display-agency="true"
                                           :hide-personal-info="true" />
                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Siblings with Olive Crest:</h4>
                <div>
                    <SiblingTable :edit-mode="EditMode"
                                  :ClientSubProgramMembershipID="ChildRecordData.Id" />
                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Family:</h4>
                <div>
                    <ContactDisplayAndEdit :edit-mode="EditMode"
                                           :global-update="false"
                                           get-endpoint="Wraparound/Clients/GetContacts"
                                           :get-payload="{Id: ChildRecordData.Id}"
                                           add-edit-endpoint="Wraparound/Clients/AddEditContact"
                                           :add-edit-payload="{ChartID: ChildRecordData.Id}"
                                           delete-endpoint="Core/Clients/Contacts/BiologicalFamily/DeleteContact"
                                           :require-dob="false"
                                           contact-category="Family"
                                           :relationship-options="FamilyRelationOptions"
                                           relationship-label="Child"
                                           :display-age="true"
                                           :display-relationship="true"
                                           :agency-input="false"
                                           :display-agency="false" />
                </div>
            </div>
        </div>
        <!--<div class="row record-section-row">
        <div class="col">
            <h4>Church Relationships:</h4>
            <div>
                <ContactDisplayAndEdit :edit-mode="EditMode"
                                       :global-update="false"
                                       get-endpoint="Core/ChildAbuseStopsHere/GetContacts"
                                       :get-payload="{Id: ChildRecordData.Id}"
                                       add-edit-endpoint="Core/ChildAbuseStopsHere/AddEditContact"
                                       :add-edit-payload="{ChartID: ChildRecordData.Id}"
                                       delete-endpoint="Core/ChildAbuseStopsHere/DeleteContact"
                                       :require-dob="false"
                                       contact-category="Church Relationship"
                                       :relationship-options="null"
                                       relationship-label="Child"
                                       :display-age="false"
                                       :display-relationship="true"
                                       :church-input="true"
                                       :display-church="true" />
            </div>
        </div>
    </div>-->
        <div class="row record-section-row">
            <div class="col">
                <h4>Informal Relationships:</h4>
                <div>
                    <InformalRelationshipsDisplayAndEdit :edit-mode="EditMode"
                                                         :chart-id="ChildRecordData.Id"
                                                         :client-first-name="ChildRecordData.Client.Person.FirstName" />
                </div>
            </div>
        </div>
        <div class="row record-section-row">
            <div class="col">
                <h4>Misc:</h4>
                <div>
                    <ContactDisplayAndEdit :edit-mode="EditMode"
                                           :global-update="false"
                                           get-endpoint="Core/Clients/Contacts/Misc/GetContacts"
                                           :get-payload="{Id: ChildRecordData.Id}"
                                           add-edit-endpoint="Core/Clients/Contacts/Misc/AddEditContact"
                                           :add-edit-payload="{ChartID: ChildRecordData.Id}"
                                           delete-endpoint="Core/Clients/Contacts/Misc/DeleteContact"
                                           :require-dob="false"
                                           contact-category="Misc"
                                           :relationship-options="null"
                                           relationship-label="Child"
                                           :display-age="false"
                                           :display-relationship="true"
                                           :agency-input="true"
                                           :display-agency="true"
                                           :hide-personal-info="true" />
                </div>
            </div>
        </div>
        <EditMode :EditMode="EditMode" @update-edit-mode="UpdateEditMode" permission="Wraparound.ClientPeople.Edit" />
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    //import components
    import ContactDisplayAndEdit from '../../../Core/ItemEditors/ContactDisplayAndEdit.vue';
    import InformalRelationshipsDisplayAndEdit from '../../../Core/ItemEditors/InformalRelationshipsDisplayAndEdit.vue';
    import SiblingTable from '../../../Core/RecordComponents/SiblingTable';
    import EditMode from '../../../Core/ItemEditors/EditMode.vue';
    export default {
        props: [
            'ChildRecordData'
        ],
        data: function () {
            return {
                EditMode: false
            };
        },
        methods: {
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            UpdateEditMode() {
                this.EditMode = !this.EditMode;
            }
        },
        components: {
            ContactDisplayAndEdit,
            EditMode,
            InformalRelationshipsDisplayAndEdit,
            SiblingTable
        },
        mounted() {

        },
        computed: {
            ProfessionalOptions: function () {
                return this.$store.state.Options.ProfessionalTypes;
            },
            FamilyRelationOptions: function () {
                return this.$store.state.Options.FamilyRelations;
            }
        }    
    }
</script>

<style scoped>
</style>